import React from 'react';
import AboutContent from '../components/aboutUs/AboutContent';


function AboutUs() {
  return (
    <>
        <AboutContent />
    </>
  );
}

export default AboutUs;